export const sv = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: 'Lägg till text',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'Lägg till i kundvagn',
  ADD_TEMPLATE: 'Add Template',
  ADJUST_SIZE_KEY: 'Adjust Size',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: 'Justera botten',
  ALIGN_CENTER_KEY: 'Centrera i linje med',
  ALIGN_KEY: 'justera',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'justera mitten',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'Justera toppen',
  ALL_TAB_TITLE_KEY: 'Alla',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',

  BASIC_HELPER_INSTRUCTION1_KEY:
    'Browse the content and select the images for your design, or upload your own',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Preview your design, or fine-tune the details',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Customize the design and add other elements to your project',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'When the design is ready, click NEXT to make a final check and place your order.',
  BACK_KEY: 'Back',
  BACKGROUND_KEY: 'Bakgrund',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY:
    'Inga inspirationer hittades under denna kategori',
  BRING_TO_FRONT_KEY: 'Placera längst fram',
  CANCEL_TEXT_KEY: ' Avbryt',
  CENTIMETERS_KEY: 'centimeter',
  CM_KEY: 'cm',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'Välj fil',
  CITY: 'City',
  CLEAR_ALL_KEY: 'Ta bort allt',
  CLEAR_COLOR_KEY: 'Rensa färg',
  CLOSE_WINDOW_KEY: 'Stäng fönster',
  CLEAR_ALL_OBJECTS: 'Ta bort alla objekt',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'Det här kommer att ta bort alla objekt från bakgrunden.',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'Färg',
  CONTINUE_KEY: 'Fortsätt...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Custom',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign-in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: 'Designa',
  DELETE_KEY: 'Radera',
  DOCUMENT_COLORS: 'Dokumentfärger',
  DONE: 'Done!',
  DONE_KEY: 'Klar',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: 'Ladda ned',
  DOWNLOAD_APP_TITLE_KEY: 'Du kan hämta appen här:',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Dropbox-import',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Dreamstime sökning',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Dreamstime bilder',
  DUPLICATE_KEY: 'Dubblera',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Redigera design',
  EDIT_LOWERCASE_KEY: 'edit',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    'Tyvärr har ett fel uppstått. Försök igen senare.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Hoppsan, det uppstod ett fel i den överförda PDF-filen.',
  EMAIL_KEY: 'E-post',
  EMAIL_ADDRESS_KEY: 'E-postadress:',
  EMAIL_CHECKBOX_MESSAGE:
    'Jag vet att den här personen är införstådd med att han eller hon kommer att få e-postmeddelanden från HP för min eller den här serviceleverantörens räkning.',
  EXTRA_INFO_KEY: 'Extra information',
  EMAIL_NOTIFICATION:
    'Ett e-postmeddelande kommer strax att skickas. Det kan ta upp till 15 minuter att bearbeta det.',
  EMAIL_DIALOG_MESSAGE:
    'Skriv e-postadressen till den person som du vill dela din design med.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'Befintlig mapp',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Försäkra dig om att du valt rätt artiklar innan du går vidare till kassan',
  FINAL_CHECK_TITLE_KEY: 'Sista kontroll',
  FINISH_KEY: 'Avsluta',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'Vänd',
  FOR_KEY: 'för',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: 'Nyckelord:',
  FOLDER_NAME: 'Mappnamn',
  FOLDER_NAME_KEY: 'Mappnamn:',
  FOLDER_ALREADY_EXIST_KEY: 'Det här mappnamnet finns redan',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Ok, I got it',
  GROUP_ALL_KEY: 'Gruppera alla',
  GROUP_SCALE: 'Skala grupp',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'Ge ditt projekt ett namn',
  HEIGHT_KEY: 'Höjd',
  HELP_KEY: 'Hjälp',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: 'BILDER',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'Importerar',
  INCHES_COLUMN_HEADER_KEY: 'Tum',
  INCHES_KEY: ' tum',
  INCHES_UNIT_STRING_KEY: 'tum',
  INVALID_EMAIL_ADDRESS_KEY: 'Ogiltig e-postadress',
  INVALID_INFO_KEY: 'Ange detaljer.',
  INVALID_NAME_KEY: 'Ogiltigt namn',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'Den valda filen är för stor. Den maximala filstorleken är 500 MB.',
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'Hoppsan, det där är inte ett giltigt filformat. Vi kan endast hantera pdf, jpg, png, svg och tif.',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'Språk',
  LASTNAME: 'Last name',
  LEARN_MORE: 'Läs mer',
  LEARN_THE_BASICS_KEY: 'Learn the basics',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'Genom att använda den här webbplatsen samtycker du till att följa dessa',
  LEGAL_FOOTER_MESSAGE2_KEY: 'Den här webbplatsen överensstämmer med',
  LEGAL_FOOTER_MESSAGE3_KEY: 'och',
  LENGTH_STRING_IN_INCHES_KEY: 'tum',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'Hämta LinkReader-appen för att visualisera innehållet du lägger till.',
  LOADING_KEY: 'Läser in...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'Lås',
  LOGIN_KEY: 'Logga in',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'Logga in på Dreamstime ',
  LOGOUT_KEY: 'Logga ut',
  MATERIAL_TITLE_KEY: 'MATERIAL',
  MATERIAL_STRING_KEY: 'Material',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    'Den här bakgrunden kan inte förminskas ytterligare eftersom du har nått den minimihöjd eller -bredd som krävs för att täcka din vägg.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Modell',
  MORE_INFO_TEXT_KEY: 'Mer info',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'Namn:',
  NEXT_BUTTON_TITLE_KEY: 'NÄSTA',
  NEW_FOLDER_KEY: 'Ny mapp',
  NO_SHADOW_KEY: 'Ingen skugga',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'Beställningsprov',
  ORDER_SAMPLE: 'Beställ ett prov',
  ORDER_SAMPLE_INFOLABEL_1:
    'Välj den del av bilden som du vill beställa som ett prov',
  ORDER_SAMPLE_INFOLABEL_2:
    'Du får ett e-postmeddelande med en närbild av projektet i verklig storlek',
  ORDER_SAMPLE_INFOLABEL_3:
    'På så sätt kan du utvärdera kvaliteten och upplösningen',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Beställ prov nu',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Få ett e-postmeddelande med en närbild av ditt projekt i verklig storlek så att du kan utvärdera dess kvalitet/upplösning.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: 'Lösenord',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Jag har copyright till den här bilden och samtycker till',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: 'Pixel',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'dvs. några viktiga saker som tryckeriet behöver veta',
  PLACEHOLDER_INCHES_STRING_KEY: 'tum',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'Position',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Spara ditt projekt',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'Ditt projekt innehåller ändringar som måste sparas innan du fortsätter.',
  PRICE_COLUMN_HEADER_KEY: 'Pris',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'Bearbetar...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'Förhandsgranska',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'Projektnamn',
  PROJECT_NAME: 'Projektnamn:',
  PROJECT_ALREADY_EXIST_KEY: 'Det här projektnamnet finns redan',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Det här projektnamnet finns redan',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Det här mappnamnet finns redan',
  PIXELATION_WARNING_KEY: 'Pixelvarning',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'På grund av upplösningen på ditt uppladdade foto kan din hud vara förvrängd eller förvrängd. För att säkerställa att det inte blir någon suddighet, vänligen ladda upp en bild av god kvalitet och undvik bildsträckning. Om du är nöjd med förhandsgranskningen och vill fortsätta, fortsätt skicka.',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: '*Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'KRÄVS',
  RECOLOR_KEY: 'Ändra färg',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'Ändra färg',
  REQUEST_SAMPLE_KEY: 'Begär ett prov',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'Resize Arbitrarily',
  RESIZE_PROPORTIONALLY_KEY: 'Resize Proportionally',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'Begäran om offert',
  RIGHT_LOGO_TEXT_KEY: 'av',
  ROTATE_KEY: 'Rotera',
  ROTATE_LEFT_KEY: 'Rotera 90Â° åt vänster',
  ROTATE_RIGHT_KEY: 'Rotera 90Â° åt höger',
  ROTATION_KEY: 'Rotation',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Rader och kolumner',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'Spara',
  SAVING_KEY: 'Sparar...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'Save template',
  SAVE_DIALOG_TITLE: 'Spara ditt projekt',
  SAVE_PROJECT_NAME_KEY: 'Spara ditt projekt först',
  SAVEDIALOG_MESSAGE:
    'Logga in för att spara ditt projekt. Om du inte har något konto hjälper vi dig att skapa ett. Det du gjort hittills försvinner inte.',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Scale the image to fit with on your design',
  SCALE_KEY: 'Skala',
  SCALE_ALL_KEY: 'Skala alla',
  SCALE_TO_FILL_KEY: 'Scale To Fill',
  SEARCH_BUTTON_TITLE_KEY: 'Sök',
  SELECT_CUSTOM_SIZE_KEY: 'Select custom size',
  SELECT_CUSTOM_KEY: 'Custom',
  SEARCH_TITLE: 'Sök',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Select poster size',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Skicka installationsanvisningar',
  SEND_TO_BACK_KEY: 'Placera längst bak',
  SEND_KEY: 'Skicka',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: 'Ange storlek',
  SETTINGS_KEY: 'Inställningar',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: 'Dela',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: 'kvfot',
  SQM_UNIT_STRING_KEY: 'kvm',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'Lämna',
  SHARE_LINK_LABEL: 'Välj den typ av länk som du vill dela',
  SHARE_EDIT_LINK: 'Redigera länk',
  SHARE_VIEW_LINK: 'Visa länk',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT:
    '* Avsett visningsavstånd kan ändras under Inställningar.',
  TERMS1_KEY: 'villkor',
  TERMS2_KEY: 'HP:s sekretessmeddelande',
  TERMS3_KEY: 'Meddelande om HP:s rättigheter till personliga data',
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: 'Villkor för användning',
  TEXT_ANCHOR_MIDDLE: 'Center',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'Sida vid sida',
  TOTAL_KEY: 'TOTALT',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'Tack',
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Lås upp',
  UNGROUP_KEY: 'Dela upp grupp',
  UPDATE_TEXT_KEY: 'Uppdatera',
  UPLOAD_KEY: 'Överför bild',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: 'Användarnamn',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'Ta bort sida vid sida',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'Giltighet',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'Moms',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'Visa i Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'Visa designdetaljer',
  VIEW_DESIGNER_PROFILE_KEY: 'Visa designverktygsprofil',
  VIEW_PRICE_KEY: 'Visa pris',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'Affisch',
  WALL_SIZE_TEXT_KEY: 'Wall size',
  WARNING_KEY: 'Varning',
  WEBSITE: 'Website',
  WIDTH_KEY: 'Bredd',

  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: 'Ditt namn',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'Ditt projekt:',
  PROJECT_NAME_ERROR_TEXT: 'Ange ett namn för ditt projekt.',
  PROJECT_FOLDER_ERROR_TEXT: 'Ange ett namn för din projektmapp.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Lägsta visningsavstånd',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Nej Sök i innehållet',
  NO_ELEMENT_ERROR_MESSAGE: 'Hittar inget element.',
  NO_MORE_IMAGES_FOUND_KEY: 'Inga fler bilder hittades',
  NO_PATTERN_ERROR_MESSAGE: 'Inga mönster hittades.',
  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: 'Meddelande:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will revieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'Du har skalat till en punkt där den utskrivna bilden kan se pixlad ut när den visas vid {0} {1} * (nuvarande utskriftsupplösning är {2} dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'Det rekommenderade visningsavståndet är  {0} {1}. Om det inte passar minskar du bildens skala eller storleken på din väggdekoration.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'Den rekommenderade minsta bildstorleken bör vara {0} x {1} pixlar.',
  UPLOAD_STATUS: '{0}% av {1}MB',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: 'Minimimåtten är {0} (b) gånger {1} (h).',
  MINIMUM_HEIGHT_KEY: 'Minimihöjden är {0}.',
  MINIMUM_WIDTH_KEY: 'Minimibredden är {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Maximum dimensions are {0} (w) by {1} (h).',
  MAXIMUM_WIDTH_KEY: 'Maximibredden är {0}',
  MAXIMUM_HEIGHT_KEY: 'Den maximala höjden är {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY: 'Ange numeriska mått som är större än noll.',
  PROCESSING_FAILED: 'Bearbetningen misslyckades, försök igen senare',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT: 'Flersidiga PDF-filer stöds tyvärr inte.',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT: 'Tyvärr stöds inte krypterade PDF-filer.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Importerar fil {0} av {1}',
  RECOLORING_KEY: 'Ändrar färg ...',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Solid Color',
  AUTHENTICATE_DIALOG_TITLE: 'Den här källan är lösenordsskyddad',
  AUTHENTICATE_FAILED_MESSAGE: 'Autentiseringen misslyckades!',
  DROPBOX_IMPORT_ERROR_HEADER: 'Det var problem med att importera vissa filer',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Project',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'Denna inspirationsmall kommer med en standardstorlek på {0} X {1} {2}. Din sidstorlek kommer att ändras automatiskt så att den passar den här mallen.',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Välj din bärbara dator',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'Förnamn',
  LAST_NAME_KEY: 'Efternamn',
  PHONE_NUMBER_KEY: 'Telefonnr',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Ogiltigt telefonnummer',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'Jag accepterar villkoren',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'Jag accepterar att mina personuppgifter delas med HP så att jag kan kontaktas om framtida HP-kampanjer.*',
  SERVICE_PROVIDER_CONDITION:
    'Jag accepterar att uppgifterna jag tillhandahåller kan delas med tjänsteleverantörer för utskrifter och leveranser.*',
  ORDER_DESIGN: 'Beställ design',
  SUBMIT_YOUR_DESIGN: 'Skicka din design',
  SUBMISSION_DESIGN_ORDER: 'Inskick för designorder',
  ENTER_REQUIRED_FIELDS_KEY: 'Fyll i de nödvändiga fälten',
  ADDRESS_KEY: 'Adress',
  INVALID_ADDRESS_KEY: 'Ogiltig adress',
  CITY_KEY: 'Ort',
  INVALID_CITY_KEY: 'Ogiltig ort',
  COUNTRY_KEY: 'Land',
  STATE_KEY: 'Kommun',
  ZIP_KEY: 'Postnummer',
  INVALID_ZIP_KEY: 'Ogiltigt postnummer',
  ORDER_NUMBER: 'Ordernummer',
  YOUR_DETAILS_KEY: 'Dina detaljer',
  APPLY_DESIGN_COMPETITION: 'Ansök om att delta i designtävlingen',
  NOTICE_KEY: 'Lägga märke till:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'För att ha en PC-hud perfekt anpassad till din, måste du välja den exakta modellen som motsvarar köpet, vilket visas på fakturan.',
  RESTART_PROJECT_ALERT_TITLE: 'Starta om ett projekt?',
  DISCARD_ALERT_MESSAGE: 'Ditt aktuella projekt kommer att kasseras',
  RESTART: 'Omstart',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Sidstorlek Varning!',
  MODIFY_SIZE_WARNING:
    'Om du vill ändra storlek på denna design kan du göra det på fliken "Inställningar". Designelement kan krävas redigering för att anpassa till önskade dimensioner.',
  RANDOMIZE_KEY: 'Randomize',
  MATERIAL_CHOICE_APPLIED: 'Materialval tillämpat.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'intyg om',
  AUTHENTICITY_STRING: 'äkthet',
  PLEASE_WAIT: 'Vänta',
  PROTECTING_YOUR_DATA: 'skyddar dina data ...',
  SEARCH_YOUR_LAPTOP_KEY: 'Sök din bärbara dator', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'hoppsan! Vi kunde inte hitta några bärbara datorer för din sökning.', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: 'Serienummer',
  LOCKED_PROJECT: 'Låst projekt',
  LOCKED_MESSAGE:
    'Detta projekt har beställts och kan inte ändras. Du kan endast visa detta projekt.',
  EXPIRED_PROJECT: 'Utgånget projekt',
  EXPIRED_MESSAGE: 'Detta projekt har löpt ut.',
  DELETED_PROJECT: 'Borttaget projekt',
  DELETED_MESSAGE: 'Detta projekt har tagits bort.',
  CHOOSE_GROUP_TYPE: 'Välj {0} typ',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Ange siffror som är större än noll.',
  SIZE_KEY: 'Storlek',
  DISTANCE_FROM_KEY: 'Avstånd från',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Furniture',
  FIXTURES_KEY: 'Fixtures',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'Vänster',
  RIGHT_KEY: 'Höger',
  DELETE_WALL_KEY: 'Delete a wall',

  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Choose canvas type',
  MAXIMUM_WALL_SIZE_KEY: 'Den maximala väggstorleken är {0} kv{1}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY: 'Dukens höjd överstiger vägghöjden.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: 'Dukens bredd överstiger väggbredden.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'Det maximala antalet kolumner för den aktuella bredden är {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'Det maximala antalet rader för den aktuella höjden är {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'Väggbredden är mindre än dukens bredd.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'Väggen måste ha en bredd på minst {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'Väggen måste ha en höjd på minst {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'Vägghöjden är mindre än dukens höjd.',
  MAXIMUM_WALL_HEIGHT_KEY: 'Den maximala vägghöjden är {0} {1}.',
  FINISHING_KEY: 'Finishing',
  MIRROR_KEY: 'Mirror',
  NATURAL_KEY: 'Natural',
  ROWS_KEY: 'Rader',
  COLUMNS_KEY: 'Kolumner',
  DEFAULT_WALL_SIZE_KEY: 'Default Wall Size',
  EDIT_KEY: 'Redigera',
  TOP_KEY: 'Överkant',
  BOTTOM_KEY: 'Nederkant'
};
